import { useState, useMemo } from 'react';

export function useParticipantState(participants: any[], initialId: string) {
    const [selectedParticipantId, setSelectedParticipantId] = useState(initialId);
    const selectedParticipant = useMemo(() =>
        participants.find(p => p.id === selectedParticipantId),
        [participants, selectedParticipantId]
    );

    return {
        selectedParticipantId,
        setSelectedParticipantId,
        selectedParticipant
    };
}

export function useFeedbackState() {
    const [expandedFeedback, setExpandedFeedback] = useState<Set<string>>(new Set());

    const toggleFeedback = (id: string) => {
        setExpandedFeedback(prev => {
            const next = new Set(prev);
            if (next.has(id)) {
                next.delete(id);
            } else {
                next.add(id);
            }
            return next;
        });
    };

    return {
        expandedFeedback,
        toggleFeedback
    };
}

export function useSimulationFilters() {
    // 조회기간 디폴트 없음 (전체 기간 조회)
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [sortCriteria, setSortCriteria] = useState('latest'); // latest, highest, lowest, all
    const [completionDates] = useState<string[]>([]); // API에서 가져온 날짜로 채워짐
    const [selectedCompletionDate, setSelectedCompletionDate] = useState('');

    return {
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        sortCriteria,
        setSortCriteria,
        completionDates,
        selectedCompletionDate,
        setSelectedCompletionDate
    };
}
